import { Divider as CKDivider } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';

const separatorStyle = {
  backgroundColor: Colors.ArmyGreen300,
  marginY: 'padding_4',
};

const Divider = () => {
  return <CKDivider sx={separatorStyle} />;
};

export default Divider;
